<template>
  <div>
    <h4>New unban</h4>
    <form @submit.prevent="unban">
      <div class="form-group">
        <label for="reason">Reason</label>
        <textarea
          v-model="reason"
          id="reason"
          class="form-control"
          rows="3"
          maxlength="1024"
          required
        />
      </div>
      <b-button :to="{name: 'player_ban_log'}">Cancel</b-button>
      <b-button type="submit" variant="primary">
        Unban
      </b-button>
    </form>
  </div>
</template>

<script>
import notifier from '../notifier';
import { HTTP } from '../http-common';

export default {
  name: 'PlayerUnbanAdd',

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      reason: '',
    };
  },

  methods: {
    unban() {
      notifier.deleteSenderNotifications(this);

      const data = new FormData();
      data.append('reason', this.reason);

      const url = '/player/' + this.playerId + '/unban';
      HTTP.post(url, data)
      .then(() => {
        this.$emit('player-unbanned');
        notifier.showSuccessAfterTransition('Player unbanned.');
        this.$router.push({name: 'player_ban_log'});
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>
